'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgChatbubbleQuestionFill } from '@common/icon';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES } from '@/constants';
import { useCategory } from './_hooks/useCategory';
import { Agencies } from './Agencies';
import { CategoryDropdown } from './CategoryDropdown';
const DONATION_SUB_HEADER_HEIGHT = 56;
const DONATION_DESKTOP_HEADER_HEIGHT = 72;
export const DONATION_DESKTOP_STICKY_TOP = DONATION_DESKTOP_HEADER_HEIGHT + DONATION_SUB_HEADER_HEIGHT;
export const DonationSubHeader = () => {
  const $ = _c(23);
  const pathname = usePathname();
  const {
    categoryData
  } = useCategory();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      top: DONATION_DESKTOP_HEADER_HEIGHT,
      height: DONATION_SUB_HEADER_HEIGHT
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== categoryData) {
    t1 = <li><CategoryDropdown categories={categoryData} className="-ml-24" /></li>;
    $[1] = categoryData;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = DONATION_ROUTES.GIFTS.pathname === pathname;
  let t3;
  if ($[3] !== t2) {
    t3 = <SubLink href={DONATION_ROUTES.GIFTS.pathname} isSelected={t2}>답례품</SubLink>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = DONATION_ROUTES.HOMETOWNS_BUSINESS.pathname === pathname;
  let t5;
  if ($[5] !== t4) {
    t5 = <SubLink href={DONATION_ROUTES.HOMETOWNS_BUSINESS.pathname} isSelected={t4}>지정기부사업</SubLink>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = DONATION_ROUTES.MY_ETC_EVENT.pathname === pathname;
  let t7;
  if ($[7] !== t6) {
    t7 = <SubLink href={DONATION_ROUTES.MY_ETC_EVENT.pathname} isSelected={t6}>이벤트</SubLink>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = DONATION_ROUTES.GUIDE.pathname === pathname;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SvgChatbubbleQuestionFill className="ml-4 size-16 text-B-500" />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t8) {
    t10 = <SubLink href={DONATION_ROUTES.GUIDE.pathname} isSelected={t8}>고향사랑기부 안내{t9}</SubLink>;
    $[10] = t8;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t3 || $[14] !== t5 || $[15] !== t7) {
    t11 = <li className="flex items-center">{t3}{t5}{t7}{t10}</li>;
    $[12] = t10;
    $[13] = t3;
    $[14] = t5;
    $[15] = t7;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t1 || $[18] !== t11) {
    t12 = <ul className="flex items-center gap-12">{t1}{t11}</ul>;
    $[17] = t1;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Agencies />;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t12) {
    t14 = <div className="sticky z-10 w-full bg-Gray-white mobile:hidden tablet:hidden" style={t0}><nav className="mx-auto flex h-full max-w-screen-xl items-center justify-between px-40">{t12}{t13}</nav></div>;
    $[21] = t12;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  return t14;
};
const SubLink = t0 => {
  const $ = _c(7);
  const {
    href,
    isSelected,
    children
  } = t0;
  const t1 = isSelected ? "page" : undefined;
  const t2 = isSelected ? "font-700 text-Gray-800" : "font-600 text-Gray-500 hover:text-Gray-700";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("flex h-56 items-center px-24 transition-colors typo-body3", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== href || $[4] !== t1 || $[5] !== t3) {
    t4 = <CustomLink href={href} aria-current={t1} className={t3}>{children}</CustomLink>;
    $[2] = children;
    $[3] = href;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};